// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1MMt_","col":"styles_col__2o2i6"};